// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Plus: React.FC<{ width?: number; height?: number }> = ({ width = 11, height = 11 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 11 11">
            <path
                fill="currentColor"
                d="M6.286.786A.776.776 0 0 0 5.5 0a.776.776 0 0 0-.786.786v3.928H.786A.776.776 0 0 0 0 5.5c0 .442.344.786.786.786h3.928v3.928c0 .442.344.786.786.786a.776.776 0 0 0 .786-.786V6.286h3.928A.776.776 0 0 0 11 5.5a.776.776 0 0 0-.786-.786H6.286V.786Z"
            />
        </svg>
    );
};

export default React.memo(Plus);
